export default __webpack_public_path__ + "static/media/woman1.9ee8a4b2.png";